(() => {
  if (window.OrigamiStudioGallery) return;
  const controllers = new WeakMap();
  const galleriesIn = root => root.matches?.('.og-studio') ? [root] : root.querySelectorAll('.og-studio');
  const init = (root = document) => {
    const galleries = galleriesIn(root);
    galleries.forEach(gallery => {
      if (gallery.dataset.ready) return;
      const track = gallery.querySelector('.og-track');
      if (!track) return;
      const slides = [...track.children];
      const buttons = [...gallery.querySelectorAll('[data-slide]')];
      if (!slides.length || buttons.length !== slides.length) return;
      gallery.dataset.ready = 'true';
      let active = 0;
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const select = i => {
        active = Math.max(0, Math.min(slides.length - 1, i));
        gallery.dataset.activeView = slides[active].dataset.view;
        buttons.forEach((button, j) => button.setAttribute('aria-pressed', String(active === j)));
        const button = buttons[active];
        const strip = button.parentElement;
        const box = button.getBoundingClientRect();
        const viewport = strip.getBoundingClientRect();
        if (box.left < viewport.left) strip.scrollBy({left: box.left - viewport.left - 4, behavior: behavior()});
        else if (box.right > viewport.right) strip.scrollBy({left: box.right - viewport.right + 4, behavior: behavior()});
      };
      const go = (i, motion = behavior()) => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: motion});
        select(i);
      };
      buttons.forEach((button, i) => button.addEventListener('click', () => go(i)));
      let pending = false;
      track.addEventListener('scroll', () => {
        if (pending || !track.clientWidth) return;
        pending = true;
        requestAnimationFrame(() => {
          select(Math.round(track.scrollLeft / track.clientWidth));
          pending = false;
        });
      }, {passive: true});
      track.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(slides.length - 1);
        else go(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      let width = track.clientWidth;
      new ResizeObserver(() => {
        if (!track.clientWidth || width === track.clientWidth) return;
        width = track.clientWidth;
        go(active, 'instant');
      }).observe(track);
      const selectView = key => {
        let index = slides.findIndex(slide => slide.dataset.view === key);
        if (index < 0) index = slides.findIndex(slide => slide.dataset.view === 'front');
        go(index < 0 ? 0 : index, 'instant');
      };
      controllers.set(gallery, {selectView});
      selectView(gallery.dataset.initialView || 'front');
    });
  };
  const selectView = (root, key) => {
    init(root);
    galleriesIn(root).forEach(gallery => controllers.get(gallery)?.selectView(key));
  };
  window.OrigamiStudioGallery = {init, selectView};
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
